import { getEvents } from '@app/analytics/models/helpers';
import { TagContainer } from '@app/analytics/models/container';
import { MmaoMakeOfferSuccess } from '@app/store';

/**
 * On product pages where price has decreased, when users complete
 * their price offer submitting the MMAO form.
 */
const events = getEvents((action: MmaoMakeOfferSuccess) => [
  {
    type: 'event',
    container: TagContainer.Analytics,
    payload: {
      event: 'productMmao',
      env_template: 'product',
      product_brand: action.payload.product.brand.name,
      product_univers: action.payload.product.universe.name,
      product_category: action.payload.product.category.name
    }
  },
  {
    type: 'MakeMeOffer',
    container: TagContainer.Media
  }
]);

export default events;
